export default __webpack_public_path__ + "static/ods-c74d5dcfd1749edf77d23e8f27c24350.jpeg";